import { ModuleFE_RuntimeActiveNavState } from './active-nav-state/ModuleFE_RuntimeActiveNavState.js';
import { ModuleFE_RuntimeActiveNavPathway } from './active-nav-pathway/ModuleFE_RuntimeActiveNavPathway.js';
export const ModulePackFE_NavigationInfo = [ModuleFE_RuntimeActiveNavState, ModuleFE_RuntimeActiveNavPathway];
//# sourceMappingURL=module-pack.js.map